<template>
    <client-only>
        <aside
            class="flex h-auto w-full shrink-0 grow-0 flex-col gap-2 lg:sticky lg:w-4/12 lg:self-start"
            :class="isCheckoutPath(route.path) ? 'lg:top-32' : 'lg:top-48'"
        >
            <div class="hidden lg:block">
                <Cart />
            </div>
        </aside>
    </client-only>
</template>

<script setup lang="ts">
    import Cart from '~/components/Cart/Cart.vue'
    import { isCheckoutPath } from '~/utils/path-utils'
    const route = useRoute()
</script>
